export default __webpack_public_path__ + "static/media/17.09525f74.jpg";